export default __webpack_public_path__ + "static/media/TARJM_Logo.0a4417df.svg";